"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var route_settings_1 = require("@reverbdotcom/commons/dist/route_settings");
var rails_view_store_1 = require("../components/discovery/rails_view_store");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var mparticle_tracker_1 = require("@reverbdotcom/commons/dist/elog/mparticle_tracker");
var RecentlyViewedRoute = (React.createElement(route_settings_1.Route, { key: "browsing_history", path: "browsing_history", props: {
        pageViewEvent: {
            pageName: mparticle_tracker_1.MParticlePageName.RecentlyViewed,
        },
    }, getComponent: function (_location, cb) {
        require.ensure([], function (require) {
            cb(null, require('../components/discovery/feed/rails_view').default);
        }, 'feed');
    }, onChange: function (_, nextState) {
        rails_view_store_1.RailsViewActions.fetchHTML('/browsing_history', nextState.location.query);
    }, onEnter: function (nextState) {
        if (is_node_1.default) {
            return;
        }
        rails_view_store_1.RailsViewActions.fetchHTML('/browsing_history', nextState.location.query);
    }, onLeave: function () {
        rails_view_store_1.RailsViewActions.clearHTML();
    } }));
exports.default = RecentlyViewedRoute;
//# sourceMappingURL=recently_viewed.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/recently_viewed.js
// module id = 1Fde
// module chunks = 20 21